import React from "react";
import style from "./CardGrid.module.scss";
import Link from "next/link";
import { API_BASE } from "../../../../constants/config";
import avatar from "../../../../public/Anonimo.webp";

export const CardGrid = ({ article, date }) => {
  const avatarUrl = typeof avatar === "string" ? avatar : avatar.src;
  return (
    <article className={style.card}>
      <Link href={`/blog/${article.attributes.slug}`}>
        <picture>
          <img
            src={
              article?.attributes?.cover?.data?.attributes?.url
                ? `${API_BASE}${article?.attributes?.cover?.data?.attributes?.url}`
                : avatarUrl
            }
            className={style.cover}
            alt="cover"
          />
        </picture>
        <div className={style.cardContent}>
          <div className={style.data}>
            <span className={style.date}>{date}</span>
            <h3 className={style.title}>{article.attributes.title}</h3>
          </div>

          <ul>
            {article?.attributes?.categories?.data?.map((tag, index) => (
              <li key={index} className={style.pill}>
                {tag.attributes.title}
              </li>
            ))}
          </ul>
        </div>
      </Link>
    </article>
  );
};
